<template>
  <button
    :type="type"
    :class="className"
    @click="onClick">
    <slot/>
  </button>
</template>

<script>
export default {
  name: 'ActionButton',
  components: {},
  props: {
    className: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'button',
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
</style>
